import { useLocation } from "react-router-dom";
import { Form, FormGroup, Table } from "reactstrap";
import React, { useEffect, useState } from "react";
import "../Home/Home.css";

export function Goto() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const teamName = searchParams.get("Team");
  const ratioSelected = searchParams.get("leagueselected");
  const attackingHome = parseFloat(searchParams.get("attack_home"));
  const DstrengthHome = parseFloat(searchParams.get("defensive_home"));
  const scoredhome_average = parseFloat(searchParams.get("ASH"));
  const scoredaway1_average = parseFloat(searchParams.get("ASA"));
  const home_pos = parseFloat(searchParams.get("home_position"));
  const homePlayed = searchParams.get("HP");
  const team_count = searchParams.get("count");

  const [data, setData] = useState([]);
  const [totalSA, setTotalSA] = useState(0);
  const [scoredaway_average, setscoredaway_average] = useState(0);
  const [attacking_away, setAttacking_away] = useState(0);
  const [selectedTeam, setSelectedTeam] = useState("");
  const [totalCA, setTotalCA] = useState(0);
  const [concededaway_average, setconcededaway_average] = useState(0);
  const [defensive_away, setdefensive_away] = useState(0);
  const API_URL = process.env.REACT_APP_DIRECT || "http://192.168.1.103:8081";

  useEffect(() => {
    fetch(`${API_URL}/table/${ratioSelected}`)
      .then((res) => res.json())
      .then((data) => {
        setData(data);
        const totalSA = data.reduce(
          (acc, curr) => acc + parseFloat(curr.SA),
          0
        );
        setTotalSA(totalSA.toFixed(2));
        const totalCA = data.reduce(
          (acc, curr) => acc + parseFloat(curr.CA),
          0
        );

        setTotalCA(totalCA.toFixed(2));

        const filteredData = data.filter((d) => d.Team === selectedTeam);
        const scoredaway_average = parseFloat(
          (totalSA / team_count).toFixed(2)
        );

        setscoredaway_average(scoredaway_average);
        const attacking_away = filteredData.map((item) =>
          parseFloat((item.SA / scoredaway_average).toFixed(2))
        );
        setAttacking_away(attacking_away);

        const concededaway_average = parseFloat(
          (totalCA / team_count).toFixed(2)
        );
        setconcededaway_average(concededaway_average);
        const defensive_away = filteredData.map((item) =>
          parseFloat((item.CA / concededaway_average).toFixed(2))
        );
        setdefensive_away(defensive_away);
      })
      .catch((err) => console.log(err));
  }, [ratioSelected, selectedTeam]);

  const filteredData = data.filter((d) => d.Team === selectedTeam);
  const currentAp = filteredData.map((item) => item.A_P);

  const awaypos = filteredData.map((item) => item.Pos);

  const expected_home_goals = (
    attackingHome,
    defensive_away,
    scoredhome_average
  ) => {
    return parseFloat(
      (attackingHome * defensive_away * scoredhome_average).toFixed(2)
    );
  };

  const expected_away_goals = (
    attacking_away,
    DstrengthHome,
    scoredaway1_average
  ) => {
    return parseFloat(
      (attacking_away * DstrengthHome * scoredaway1_average).toFixed(2)
    );
  };

  const factorial = (n) => (n === 0 ? 1 : n * factorial(n - 1));

  const poissonProbability = (lambda, k) => {
    return (Math.exp(-lambda) * Math.pow(lambda, k)) / factorial(k);
  };

  const homeTeam = {
    name: "Home Team",
    lambda: expected_home_goals(
      attackingHome,
      defensive_away,
      scoredhome_average
    ),
  };
  const awayTeam = {
    name: "Away Team",
    lambda: expected_away_goals(
      attacking_away,
      DstrengthHome,
      scoredaway1_average
    ),
  };

  const tableData = [];
  const headerRow = ["Away \\ Home"];
  for (let homeGoal = 0; homeGoal <= 5; homeGoal++) {
    headerRow.push(homeGoal);
  }
  tableData.push(headerRow);

  for (let awayGoal = 0; awayGoal <= 5; awayGoal++) {
    const rowData = [awayGoal];
    for (let homeGoal = 0; homeGoal <= 5; homeGoal++) {
      const homeProbability = poissonProbability(homeTeam.lambda, homeGoal);
      const awayProbability = poissonProbability(awayTeam.lambda, awayGoal);
      const jointProbability = homeProbability * awayProbability;
      rowData.push((jointProbability * 100).toFixed(2) + "%");
    }
    tableData.push(rowData);
  }

  const [totals, setTotals] = useState({
    totalHomeWinPercentage: 0,
    totalAwayWinPercentage: 0,
    totalDrawPercentage: 0,
    totalPercentageTotalScore3OrMore: 0,
    totalPercentageTotalScore20rless: 0,
    highestProbability: 0,
    secondHighestProbability: 0,
    highestProbability1: 0,
    highestProbabilityPosition: { row: -1, col: -1 },
    secondHighestProbabilityPosition: { row: -1, col: -1 },
  });

  useEffect(() => {
    let totalHomeWinPercentage = 0;
    let totalAwayWinPercentage = 0;
    let totalDrawPercentage = 0;
    let totalPercentageTotalScore3OrMore = 0;
    let totalPercentageTotalScore20rless = 0;
    let highestProbability1 = 0;
    let highestProbability = 0;
    let secondHighestProbability = 0;
    let highestProbabilityPosition = { row: -1, col: -1 };
    let secondHighestProbabilityPosition = { row: -1, col: -1 };

    tableData.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        // Ensure cell is a string before calling replace
        if (typeof cell === "string" && cell.includes("%")) {
          const probability = parseFloat(cell.replace("%", ""));

          if (probability > highestProbability1) {
            highestProbability1 = probability;
          }

          if (probability > highestProbability) {
            secondHighestProbability = highestProbability;
            secondHighestProbabilityPosition = {
              ...highestProbabilityPosition,
            };
            highestProbability = probability;
            highestProbabilityPosition = { row: rowIndex, col: colIndex };
          } else if (
            probability > secondHighestProbability &&
            probability < highestProbability
          ) {
            secondHighestProbability = probability;
            secondHighestProbabilityPosition = { row: rowIndex, col: colIndex };
          }

          const isHomeWin =
            colIndex > 0 &&
            homeTeam.lambda > awayTeam.lambda &&
            colIndex > rowIndex;
          const isDraw =
            rowIndex === colIndex && rowIndex !== 0 && colIndex !== 0;
          const isAwayWin =
            colIndex > 0 &&
            awayTeam.lambda > homeTeam.lambda &&
            rowIndex > colIndex;

          if (isHomeWin && rowIndex !== 0) {
            totalHomeWinPercentage += probability;
          }

          if (isAwayWin && colIndex !== 0) {
            totalAwayWinPercentage += probability;
          }

          if (isDraw) {
            totalDrawPercentage += probability;
          }

          // Check if the sum of home and away scores is greater than or equal to 3
          if (
            (row[0] <= 5 && colIndex === 1 && row[0] >= 3) ||
            (row[0] <= 5 && colIndex === 2 && row[0] >= 2) ||
            (row[0] <= 5 && colIndex === 3 && row[0] >= 1) ||
            (row[0] <= 5 && colIndex >= 4)
          ) {
            totalPercentageTotalScore3OrMore += parseFloat(
              cell.replace("%", "")
            );
          }

          // Check if the sum of home and away scores is less than or equal to 2
          if (
            (row[0] <= 2 && colIndex === 1 && row[0] >= 0) ||
            (row[0] <= 1 && colIndex === 2 && row[0] >= 0) ||
            (row[0] === 0 && colIndex === 3)
          ) {
            totalPercentageTotalScore20rless += parseFloat(
              cell.replace("%", "")
            );
          }
        }
      });
    });

    setTotals({
      totalHomeWinPercentage,
      totalAwayWinPercentage,
      totalDrawPercentage,
      totalPercentageTotalScore3OrMore,
      totalPercentageTotalScore20rless,
      highestProbability,
      secondHighestProbability,
      highestProbability1,
      highestProbabilityPosition,
      secondHighestProbabilityPosition,
    });
  }, [tableData]);

  const {
    totalHomeWinPercentage,
    totalAwayWinPercentage,
    totalDrawPercentage,
    totalPercentageTotalScore3OrMore,
    totalPercentageTotalScore20rless,
    highestProbability1,
    secondHighestProbability,
    highestProbabilityPosition,
    secondHighestProbabilityPosition,
  } = totals;

  const difference = highestProbability1 - secondHighestProbability;
  let diff_draw = Math.abs(
    totalHomeWinPercentage - totalPercentageTotalScore3OrMore
  );
  if (totalHomeWinPercentage === 0) {
    diff_draw = Math.abs(
      totalAwayWinPercentage - totalPercentageTotalScore3OrMore
    );
  }

  return (
    <div className="alg1_card">
      <div className="search_team">
        simo {ratioSelected}
        <Form className="form_element">
          <FormGroup>
            <select
              className="form-select"
              aria-label="Default select example"
              value={selectedTeam}
              onChange={(e) => setSelectedTeam(e.target.value)}
            >
              <option value="">Choose Away Team</option>
              {[...new Set(data.map((d) => d.Team))].map((team, i) => (
                <option key={i} value={team}>
                  {team}
                </option>
              ))}
            </select>
          </FormGroup>
        </Form>
      </div>
      <h1>sds</h1>
      Away team: {selectedTeam}
      <br />
      Home Team: {teamName}
      <br />
      Attacking strength home: {attackingHome}
      <br />
      Defensive strength home: {DstrengthHome}
      <br />
      Average scored home sum:{" "}
      <span className="average_home_sum">{scoredhome_average}</span>
      <br />
      Average scored away sum:
      <span className="average_away_sum"> {scoredaway1_average}</span>
      <br />
      Average conceded away sum: {totalCA}
      <br />
      Average scored away sum: {totalSA}
      <br />
      Attacking strength away: {attacking_away}
      <br />
      Defensive strength away: {defensive_away}
      <br />
      {teamName} expected goals:{" "}
      <span className="Home_results">
        {expected_home_goals(attackingHome, defensive_away, scoredhome_average)}
      </span>
      <br />
      {selectedTeam} expected goals:{" "}
      <span className="Away_results">
        {expected_away_goals(
          attacking_away,
          DstrengthHome,
          scoredaway1_average
        )}
      </span>
      <br />
      <div className="poisson1">
        <h2>Football Match Probabilities</h2>

        <p>Calculations</p>
        <Table bordered style={{ width: "70%", margin: "auto" }}>
          <thead>
            <tr>
              {tableData[0].map((header, index) => (
                <th
                  key={index}
                  style={{
                    width: `${100 / tableData[0].length}%`,
                    textAlign: "center",
                  }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.slice(1).map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, colIndex) => {
                  const isDraw = rowIndex + 1 === colIndex;
                  const isHomeWin =
                    colIndex > 0 &&
                    homeTeam.lambda > awayTeam.lambda &&
                    colIndex > rowIndex;
                  const isAwayWin =
                    colIndex > 0 &&
                    awayTeam.lambda > homeTeam.lambda &&
                    rowIndex > colIndex;

                  const cellClass = `${isDraw ? "draw-cell" : ""} ${
                    isHomeWin ? "win-cell-home" : ""
                  } ${isAwayWin ? "win-cell-away" : ""}`;

                  return (
                    <td
                      key={colIndex}
                      className={cellClass}
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        backgroundColor: isDraw
                          ? "yellow"
                          : isAwayWin
                          ? "red"
                          : isHomeWin
                          ? "green"
                          : null,
                      }}
                    >
                      {cell}
                      {rowIndex === highestProbabilityPosition.row &&
                      colIndex === highestProbabilityPosition.col ? (
                        <span>*</span>
                      ) : null}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </Table>
        {/* card */}
        <br />
        <div
          style={{
            backgroundColor: "#f5f5f5",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <div>
            <p>
              Home Win:
              <span className="homeWin">
                {" "}
                {totalHomeWinPercentage.toFixed(1)}
              </span>{" "}
              %
            </p>
            <p>
              Away Win:
              <span className="Away_win">
                {totalAwayWinPercentage.toFixed(1)}
              </span>{" "}
              %
            </p>
            <p>
              Draw:
              <span className="Draw">{totalDrawPercentage.toFixed(1)}</span> %
            </p>
            <p>
              Over 2.5:
              <span className="over2_5">
                {totalPercentageTotalScore3OrMore.toFixed(1)}
              </span>{" "}
              %
            </p>
            <p>
              Under 2.5:{" "}
              <b>
                {" "}
                <span className="under2_5">
                  {totalPercentageTotalScore20rless.toFixed(1)}
                </span>{" "}
                %
              </b>
            </p>
          </div>
          <div>
            <p>
              Highest Probability:{" "}
              <span className="highestProp">
                {highestProbability1.toFixed(2)}
              </span>{" "}
            </p>
            <p>
              Correct Score_1(HP):
              <span className="score_1">
                {highestProbabilityPosition.col - 1}:
                {highestProbabilityPosition.row - 1}
              </span>{" "}
            </p>

            <p>
              Second Highest Probability:{" "}
              <span className="secondProp">
                {secondHighestProbability.toFixed(2)}
              </span>{" "}
            </p>
            <p>
              Correct Score_2(HP):{" "}
              <span className="score_2">
                {" "}
                {secondHighestProbabilityPosition.col - 1}:
                {secondHighestProbabilityPosition.row - 1}
              </span>{" "}
            </p>
            <p>
              Difference:{" "}
              <span className="difference">{difference.toFixed(2)}</span>{" "}
            </p>
            {difference < 2.4 ? (
              <p
                style={{
                  color: "white",
                  backgroundColor: "green",
                  fontSize: "1.2em",
                  fontWeight: "500",
                  width: "10vw",
                  height: "5vh",
                  textAlign: "center",
                }}
              >
                yes (GG)
              </p>
            ) : (
              <p>no over</p>
            )}
          </div>
          <div>
            <p>win:over difference: {diff_draw.toFixed(1)}</p>
            {diff_draw <= 10 ? (
              <p
                style={{
                  color: "white",
                  backgroundColor: "green",
                  fontSize: "1.2em",
                  fontWeight: "500",
                  width: "10vw",
                  height: "5vh",
                  textAlign: "center",
                }}
              >
                YES (over 2.5)
              </p>
            ) : null}
            {difference < 2.4 && diff_draw <= 10 ? (
              <p
                style={{
                  color: "white",
                  backgroundColor: "green",
                  fontSize: "1.2em",
                  fontWeight: "500",
                  width: "12vw",
                  height: "5vh",
                  textAlign: "center",
                }}
              >
                Yes (GG & OVER)
              </p>
            ) : null}
            <p>
              Home_position: <span className="home_pos">{home_pos} </span>{" "}
            </p>
            <p>
              {" "}
              Away_position: <span className="away_pos">{awaypos} </span>{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
